import React, { useCallback } from "react";
import styles from "./Admin.module.scss";
import * as cookie from "../../db/cookie";
import Login from "../../components/Login/Login";
import { useAuth } from "../../Context/AuthContext";
import { useState } from "react";

export default function Admin() {
  const { logIn } = useAuth();

  const [info, setInfo] = useState<{ email: string; password: string }>({
    email: "",
    password: "",
  });
  const getCookie = cookie.getCookie("career-token");
  const onClickLogin = useCallback(() => {
    return logIn(info.email, info.password).then((res) =>
      window.location.reload()
    );
  }, [info.email, info.password, logIn]);
  return (
    <>
      {getCookie ? (
        <div></div>
      ) : (
        <Login setInfo={setInfo} onClickLogin={onClickLogin} />
      )}
    </>
  );
}
